export const logoNegative = ['608 134', `
  <title>WHAKAARO</title>
  <span>WHAKAARO</span>
`]
